<div class="page-header">
  <div class="row align-items-center flex-nowrap">
    <div class="col-auto d-lg-none">
      <button
        class="sidenav__toggle"
        id="toggle_side_nav"
        (click)="onSideNavToggleClicked()">
        <i class="iconoir-menu"></i>
      </button>
    </div>
    <div class="col">
      <div class="page-title">{{ pageTitle | async }}</div>
    </div>
  </div>
  <div class="row align-items-center gx-2 flex-nowrap">
    @if (hasNavigationAccess()) {
      <div class="col-auto">
        <div
          display="dynamic"
          placement="bottom-end"
          ngbDropdown
          class="notification-dropdown">
          <button
            class="btn btn-dark"
            id="notificationDropDown"
            ngbDropdownToggle>
            <i class="iconoir-bell pe-2 d-none d-sm-inline-flex"></i>
            <span class="badge rounded-pill">{{ taskCount() }}</span>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="notificationDropDown">
            <app-notification-dropdown [tasks]="tasks()" />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="header-item-divider"></div>
      </div>
    }
    <div class="col-auto">
      <app-profile-dropdown [hasNavigationAccess]="hasNavigationAccess()"></app-profile-dropdown>
    </div>
  </div>
</div>
